import api from './client'
import type { LeaveActivityLog, LeaveMonthlyReport, LeaveRequest, LeaveRequestType, LeaveStatus } from '../types'

export interface LeavePayload {
  projectId?: string
  requestType?: LeaveRequestType
  startDate: string
  endDate: string
  startTime?: string | null
  endTime?: string | null
  leaveType?: string | null
  reason?: string | null
  verbalApprovalConfirmed: boolean
}

export interface LeaveListParams {
  projectId?: string
  status?: LeaveStatus
  employeeId?: string
  requestType?: LeaveRequestType
}

export const leavesApi = {
  listLeaves: (params?: LeaveListParams) =>
    api.get<{ data: LeaveRequest[] }>('/leaves', { params }),
  getUpcoming: (params?: Pick<LeaveListParams, 'projectId'>) =>
    api.get<{ data: LeaveRequest[] }>('/leaves/upcoming', { params }),
  getLeave: (id: string) =>
    api.get<{ data: LeaveRequest }>(`/leaves/${id}`),
  applyLeave: (data: LeavePayload) =>
    api.post<{ data: LeaveRequest }>('/leaves', data),
  updateLeave: (id: string, data: Partial<LeavePayload>) =>
    api.put<{ data: LeaveRequest }>(`/leaves/${id}`, data),
  approveLeave: (id: string, note?: string) =>
    api.post<{ data: LeaveRequest }>(`/leaves/${id}/approve`, { note }),
  rejectLeave: (id: string, reason?: string) =>
    api.post<{ data: LeaveRequest }>(`/leaves/${id}/reject`, { reason }),
  cancelLeave: (id: string, cancellationReason?: string) =>
    api.post<{ data: LeaveRequest }>(`/leaves/${id}/cancel`, { cancellationReason }),
  addCompensation: (id: string, data: { compensationDate: string; startTime: string; endTime: string; note?: string | null }) =>
    api.post<{ data: LeaveRequest }>(`/leaves/${id}/compensations`, data),
  monthlyReport: (params: { month: string; employeeId?: string; status?: LeaveStatus; requestType?: LeaveRequestType }) =>
    api.get<{ data: LeaveMonthlyReport }>('/leaves/reports/monthly', { params }),
  monthlyReportExportUrl: (params: { month: string; employeeId?: string; status?: LeaveStatus; requestType?: LeaveRequestType }) => {
    const search = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value) search.set(key, value)
    })
    return `/api/leaves/reports/monthly/export?${search.toString()}`
  },
  getActivity: (id: string) =>
    api.get<{ data: LeaveActivityLog[] }>(`/leaves/${id}/activity`),
}
